import {useI18n} from 'i18n/I18nContext'
import usePayment from 'organization/Billing/Payments/usePayment'
import {useOrganizationEvent} from 'organization/Event/OrganizationEventProvider'
import {
  useParamEventId,
  useParamOrganizationId,
} from 'organization/OrganizationRoutes'
import {toast} from 'react-toastify'

export default function useEventPayment() {
  const {t} = useI18n()
  const {newPayment} = usePayment()
  const {get: refreshEvent} = useOrganizationEvent()
  const organizationId = useParamOrganizationId()
  const eventId = useParamEventId()
  const onSuccess = () => {
    refreshEvent()
    toast.success(t('orgBilling.toastPaymentSuccess'))
  }

  const payment = (requestData: {[x: string]: any}) => {
    return newPayment(
      `api/payment/organization/${organizationId}/event/${eventId}/pay`,
      `api/payment/organization/${organizationId}/event/${eventId}/confirm-pay`,
      requestData,
      onSuccess,
    )
  }

  return {
    payment,
  }
}
